import App from './containers/App'
export default App
